import { useEffect, useState } from 'react';
import { MotionConfig, useReducedMotion } from 'framer-motion';
import Lenis from 'lenis';
import { Toaster } from './components/ui/sonner';
import { Navbar } from './components/site/Navbar';
import { Hero } from './components/site/Hero';
import { About, Expertise, Healthcare, Marquee } from './components/site/Purpose';
import { CollegeSupport } from './components/site/CollegeSupport';
import { Approach, Services, Sustainability } from './components/site/Solutions';
import { WhyQualinova } from './components/site/WhyQualinova';
import { Partners } from './components/site/Partners';
import { Events } from './components/site/Events';
import { Contact } from './components/site/Contact';
import { Footer } from './components/site/Footer';
import './App.css';
import './account/account.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './account/AuthContext';
import AuthPage, { AuthCallback, VerifyEmailPage } from './account/AuthPage';
import Dashboard from './account/Dashboard';
import { Assistant } from './account/Assistant';
import { ResponsibilityRibbon } from './components/site/Sustainability';
import './healthcare-refresh.css';
import './components/site/Engagement.css';

function LandingPage() {
  const location = useLocation();
  const reduced = useReducedMotion();
  const [selectedService, setSelectedService] = useState(null);
  useEffect(() => {
    const lenis = reduced ? null : new Lenis({ duration: 1.15, smoothWheel: true, anchors: false, autoRaf: true });
    // One owner for anchor navigation: numeric document coordinates avoid the
    // browser/hash and Lenis element-offset calculations competing on long jumps.
    const navigate = event => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const anchor = event.target.closest('a[href^="#"]');
      if (!anchor || anchor.target === '_blank') return;
      const hash = anchor.getAttribute('href');
      const target = document.getElementById(hash.slice(1));
      if (!target) return;
      event.preventDefault();
      const headerHeight = document.querySelector('.site-header')?.getBoundingClientRect().height || 0;
      const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - headerHeight);
      if (window.location.hash !== hash) window.history.pushState(null, '', hash);
      const focusTarget = () => { if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); };
      if (lenis) lenis.scrollTo(top, { force: true, onComplete: focusTarget });
      else { window.scrollTo({ top, behavior: 'instant' }); focusTarget(); }
    };
    document.addEventListener('click', navigate);
    const frame = requestAnimationFrame(() => {
      const target = location.hash ? document.getElementById(location.hash.slice(1)) : null;
      const headerHeight = document.querySelector('.site-header')?.getBoundingClientRect().height || 0;
      const top = target ? Math.max(0, target.getBoundingClientRect().top + window.scrollY - headerHeight) : 0;
      if (lenis) { lenis.resize(); lenis.scrollTo(top, { immediate: true, force: true }); }
      else window.scrollTo({ top, behavior: 'instant' });
    });
    return () => { cancelAnimationFrame(frame); document.removeEventListener('click', navigate); lenis?.destroy(); };
  }, [reduced, location.hash]);
  const enquire = (title, message) => setSelectedService({ title, message, time: Date.now() });
  return <><a href="#main-content" className="skip-link" data-testid="skip-to-content">Skip to content</a><Navbar/><main id="main-content"><Hero onEnquire={enquire}/><ResponsibilityRibbon/><About/><Marquee/><Expertise onEnquire={enquire}/><CollegeSupport onEnquire={enquire}/><Healthcare/><Approach/><Services onEnquire={enquire}/><Sustainability onEnquire={enquire}/><WhyQualinova/><Partners/><Events onEnquire={enquire}/><Contact selectedService={selectedService}/></main><Footer/></>;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) return <AuthCallback/>;
  return <><Routes><Route path="/" element={<LandingPage/>}/><Route path="/login" element={<AuthPage/>}/><Route path="/register" element={<AuthPage mode="register"/>}/><Route path="/forgot-password" element={<AuthPage mode="forgot"/>}/><Route path="/reset-password" element={<AuthPage mode="reset"/>}/><Route path="/verify-email" element={<VerifyEmailPage/>}/><Route path="/dashboard" element={<Dashboard/>}/><Route path="*" element={<LandingPage/>}/></Routes>{['/', '/dashboard'].includes(location.pathname) && <Assistant/>}<Toaster position="top-right" richColors/></>;
}

function App() { return <MotionConfig reducedMotion="user"><BrowserRouter><AuthProvider><AppRouter/></AuthProvider></BrowserRouter></MotionConfig>; }

export default App;